<template>
  <div style="height: 600px">
    <KLVideo ref="klvideo" style="height: 100%; width: 100%" />
  </div>
</template>

<script>
import KLVideo from "./KLVideo";
import { queryVideoDeviceNo } from "@/http/vehicle";
export default {
  name: "SingleVehicleVedioMonitor",
  components: {
    KLVideo,
  },
  props: {
    vehicleInfo: {
      type: Object,
      default: {
        vehicleName: "",
        nodeValue: 0,
      },
    },
  },
  watch: {
    vehicleInfo: {
      handler() {
        console.log("开启视频1");
        this.carNo = this.vehicleInfo.vehicleName;
        this.ManufactureID = this.vehicleInfo.manuID;

        //todo 先去获取车辆的视频终端编号，然后开启视频
        this.checkOpenVideo();
      },
      immediate: true,
    },
  },
  data() {
    return {
      carNo: "", //车牌号
      ManufactureID: "", //出厂编号
      deviceNo: "", //004014000022 设备编号 004011000069 https://ws.kingwings.cn/live/004014000022_02.flv
      monitorChannelList: [],
    };
  },
  mounted() {},
  methods: {
    checkOpenVideo() {
      //通过车号获取车辆的视频编号，如果没有，提示没有，如果有，开启视频
      queryVideoDeviceNo({
        ManufactureID: this.ManufactureID,
      }).then((res) => {
        // console.log(res);
        if(res.code==200 && res.data.length>0&& res.data[0].DeviceNo!=""){
          this.deviceNo = res.data[0].DeviceNo;
          this.open();
        }
        else{
          //提示，没有视频设备
          this.$message({
            message: this.$t("tree.该车辆没有配置视频设备,请联系销售人员"),
            type: "warning", 
          })
        }
      });
      // this.deviceNo="004014000022";
      // 
    },
    open() {
      console.log("开启视频");
      this.startRequestVideo();
    },
    startRequestVideo() {
      //开启定时器，总共执行4次，每次间隔1秒，执行完停止定时器

      let count = 0;
      // 新增：定义定时器
      let timer = setInterval(() => {
        if (count < 4) {
          // 发送请求
          this.$refs.klvideo.SetWait(this.deviceNo, count + 1, this.carNo);
          count++;
        } else {
          // 停止定时器
          clearInterval(timer);
        }
      }, 1000);
    },
    closeWin() {
      this.$refs.klvideo.closeAllWnd();
    },
    handleClose() {},
  },
};
</script>

<style scoped></style>
